<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <div [class]="classPrefix('Pod0Item0')">
      <wml-input-zero [class]="classPrefix('Pod0Input0')" [props]="props.input"></wml-input-zero>
      <wml-button-one  [class]="classPrefix('Pod0Btn0') "[props]="searchBtn"></wml-button-one>
    </div>
  </section>
</div>

